import 'ol/ol.css';
import TileLayer from 'ol/layer/Tile.js';
import {fromLonLat} from 'ol/proj';
import OSM from 'ol/source/OSM.js';
import {Map, View, Feature} from 'ol';
import Circle from 'ol/geom/Circle.js';
import {Fill, Stroke, Style, Text} from 'ol/style.js';
import {Control, defaults as defaultControls} from 'ol/control.js';
import sourceVector from 'ol/source/Vector.js';
import layerVector from 'ol/layer/Vector.js';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom/dist/chartjs-plugin-zoom.js';
Chart.register(zoomPlugin);
import annotationPlugin from 'chartjs-plugin-annotation/dist/chartjs-plugin-annotation.js';
Chart.register(annotationPlugin);
import graph_temp from './graph_temp.js'
import graph_pcpn from './graph_pcpn.js'
import graph_wind from './graph_wind.js'
import graph_flux_solaire from './graph_flux_solaire.js'
import graph_fumee from './graph_fumee.js'
import WMSCapabilities from 'ol/format/WMSCapabilities.js';

const controller = new AbortController();
const { signal } = controller;

class Time_Series {
  constructor(){
    this.id_model = document.getElementById('id_model');
    this.id_model_side = document.getElementById('id_model_side');
    this.id_var = document.getElementById('id_var');
    this.id_var_side = document.getElementById('id_var_side');
    this.id_start = document.getElementById('id_start');
    this.id_start_side = document.getElementById('id_start_side');
    this.id_end = document.getElementById('id_end');
    this.id_end_side = document.getElementById('id_end_side');
    this.id_delta = document.getElementById('id_delta');
    this.id_delta_side = document.getElementById('id_delta_side');
    this.id_message = document.getElementById('id_message');
    this.progress_bar = new Progress_bar(document.getElementById("id_progress"));
    this.request_completed=1;
    this.chart = null;
    this.grid_point_coor = null;
    this.grid_point_circle = null;
    this.bbox=null;
    this.now=null;
    this.dateo_stmp=null;
    this.datef_stmp=null;
    this.dateo=null;
    this.hh_min_delta_fcst=null;
    this.mod_lay=null;
    this.title=null;
    this.lat=this.lir_cook('series_lat');
    this.lon=this.lir_cook('series_lon');
    this.cap=null;
    this.ec_wms_url="https://geo.weather.gc.ca/geomet?SERVICE=WMS&VERSION=1.3.0"
    var draw_circle=false;
    if(this.lat == "" || this.lon == ""){
      this.lat=45.5;
      this.lon=-73.68;
    }else{
      draw_circle=true;
    }
    var zoom=this.lir_cook('series_zoom');
    if(zoom == ""){
      zoom=6;
    }	    
    this.map = new Map({
      target: 'id_map',
      layers: [
	new TileLayer({
	  source: new OSM()
	})
      ],
      view: new View({
	// Zoom over sourthern Quebec.
	center: fromLonLat([this.lon,this.lat]),
	zoom: zoom
      })
    });
    //if(draw_circle){
    //  if(this.grid_point_circle){
    //	this.grid_point_circle.clear();
    //  }
    //  this.grid_point_circle=this.circle([this.lon,this.lat]);
    //}
    // Construct menues
    // Model menu list
    var models=["RDPS|RDPS","HRDPS|HRDPS","GDPS|GDPS","RAQDPS|RAQDPS"];
    // Variable mune lists
    this.variables=new Array();
    this.variables[0]=["wind|Vent", "temp|Temperature", "pcpntype|Type PCPN","SN|Neige","RN|pluie","FR|verglas","PE|grésil","PR|PCPN Totale","NT|Flux solaire, nuages"];
    this.variables[1]=[...this.variables[0]];
    this.variables[2]=[...this.variables[0]];
    this.variables[3]=["fumee|Fumée"];
    // End hour menu list
    var starts=["dateo|origine","now|maintenant"];
    var ends=["6|6","12|12","24|24","36|36","48|48","72|3 jours","168|7 jours"];
    var deltas=["1|1","3|3","6|6","12|12","24|24"];          
    this.id_model.options.length=0;
    this.id_model_side.options.length=0;
    for (var i=0; i<models.length; i++){
      this.id_model.options[this.id_model.options.length]=new Option(models[i].split("|")[1], models[i].split("|")[0])
      this.id_model_side.options[this.id_model_side.options.length]=new Option(models[i].split("|")[1], models[i].split("|")[0])
    }
    this.id_var.options.length=0;
    this.id_var_side.options.length=0;
    for (var i=0; i< this.variables[0].length; i++){
      this.id_var.options[this.id_var.options.length]=new Option( this.variables[0][i].split("|")[1],  this.variables[0][i].split("|")[0])
      this.id_var_side.options[this.id_var_side.options.length]=new Option(this.variables[0][i].split("|")[1],  this.variables[0][i].split("|")[0])
    }
    this.id_start.options.length=0;
    this.id_start_side.options.length=0;
    for (var i=0; i<starts.length; i++){
      this.id_start.options[this.id_start.options.length]=new Option(starts[i].split("|")[1], starts[i].split("|")[0])
      this.id_start_side.options[this.id_start_side.options.length]=new Option(starts[i].split("|")[1], starts[i].split("|")[0])
    }
    this.id_end.options.length=0;
    this.id_end_side.options.length=0;
    for (var i=0; i<ends.length; i++){
      this.id_end.options[this.id_end.options.length]=new Option(ends[i].split("|")[1], ends[i].split("|")[0])
      this.id_end_side.options[this.id_end_side.options.length]=new Option(ends[i].split("|")[1], ends[i].split("|")[0])
    }
    this.id_delta.options.length=0;
    this.id_delta_side.options.length=0;
    for (i=0; i<deltas.length; i++){
      this.id_delta.options[this.id_delta.options.length]=new Option(deltas[i].split("|")[1]+"h", deltas[i].split("|")[0])
      this.id_delta_side.options[this.id_delta_side.options.length]=new Option(deltas[i].split("|")[1]+"h", deltas[i].split("|")[0])
    }
  }

  init_with_cookies(){
    var index=this.lir_cook('series_model_index');
    if(index != ""){
      this.id_model.selectedIndex=index;
      this.id_model_side.selectedIndex=index;
      this.update_var(index);
    }
    index=this.lir_cook('series_'+this.id_model.value+'_var_index');
    if(index != ""){
      this.id_var.selectedIndex=index;
      this.id_var_side.selectedIndex=index;
    }
    index=this.lir_cook('series_start_index');
    if(index != ""){
      this.id_start.selectedIndex=index;
      this.id_start_side.selectedIndex=index;
    }else{
      this.id_start.selectedIndex=1;
      this.id_start_side.selectedIndex=1;
    }
    index=this.lir_cook('series_end_index');
    if(index != ""){
      this.id_end.selectedIndex=index;
      this.id_end_side.selectedIndex=index;
    }
    index=this.lir_cook('series_delta_index');
    if(index != ""){
      this.id_delta.selectedIndex=index;
      this.id_delta_side.selectedIndex=index;
    }
  }
  
  update_var(selectedIndex){
    var previous_value=this.lir_cook('series_'+this.id_model.value+'_var_index');
    this.id_var.options.length=0;
    this.id_var_side.options.length=0;
    var index=-1;
    for (var i=0; i<this.variables[selectedIndex].length; i++){
      if(this.variables[selectedIndex][i].split("|")[0] == previous_value){
	index=i
      }
      this.id_var.options[this.id_var.options.length]=new Option(this.variables[selectedIndex][i].split("|")[1], this.variables[selectedIndex][i].split("|")[0])
      this.id_var_side.options[this.id_var_side.options.length]=new Option(this.variables[selectedIndex][i].split("|")[1], this.variables[selectedIndex][i].split("|")[0])
    }
    if(index != -1){
      this.id_var_side.selectedIndex=index;
      this.id_var.selectedIndex=index;
    }else{
      var index = this.lir_cook('series_'+this.id_model.value+'_var_index');
      if(index){
	this.id_var.selectedIndex=index;
	this.id_var_side.selectedIndex=index;
      } else {
	index=0;
	this.id_var_side.selectedIndex=index;
      }
    }
    this.cre_cook('series_'+this.id_model.value+'_var_index',index);
  }
  
  async get_data(lat,lon){
    this.id_message.innerHTML = "T&eacute;l&eacute;chargement des donn&eacute;es ..."
    // Effacer le cercle sur la carte si present
    if(this.grid_point_circle){
      this.grid_point_circle.clear();
    }
    // Abort any fetch requests
    if(this.request_completed == 0 ){
      controller.abort();
      this.request_completed=1;
      return
    }
    this.request_completed=0;
    var lat_min=lat-.0001;
    var lat_max=lat+.0001;
    var lon_min=lon-.0001;
    var lon_max=lon+.0001;
    this.bbox=lat_min+','+lon_min+','+lat_max+','+lon_max
    if(this.id_model.value == "RDPS" ){
      this.mod_lay=this.id_model.value+'.ETA_TT';
    }else if( this.id_model.value == "HRDPS"){
      this.mod_lay=this.id_model.value+'.CONTINENTAL_TT';
    } else if (this.id_model.value == "GDPS"){
      this.mod_lay=this.id_model.value+'.ETA_TT';
    } else if (this.id_model.value == "RAQDPS"){
      this.mod_lay=this.id_model.value+'.EATM_PM2.5';
    } else {
      console.log("Internale error in class Time_Series, please add model "+this.id_model.value)
      return
    }
    this.progress_bar.update_progress_bar(0.01);
    this.cap = await this.get_layer_capability();
    this.dateo_stmp=this.crack_cap("dateo");
    this.datef_stmp=this.crack_cap("datef");
    this.hh_min_delta_fcst=this.crack_cap("hh_min_delta_fcst");
    this.dateo=this.get_date_from_wms_date_stmp(this.dateo_stmp,'local');
    this.datef=this.get_date_from_wms_date_stmp(this.datef_stmp,'local');
    this.hhh_end=(this.get_date_from_wms_date_stmp(this.datef_stmp,'local') -
		  this.get_date_from_wms_date_stmp(this.dateo_stmp,'local'))/(1000*60*60);
    //console.log(this.dateo_stmp);
    //console.log(this.dateo);
    //console.log(this.datef_stmp);
    //console.log(this.datef);
    //console.log(this.hh_min_delta_fcst);
    //console.log(this.hhh_end);
    if( parseInt(this.id_delta.value) < parseInt(this.hh_min_delta_fcst) ){
      this.progress_bar.update_progress_bar(0.0);
      alert("L'interval doit être plus grand ou égal à "+String(this.hh_min_delta_fcst)+'h, vous avez choisi '+String(this.id_delta.value)+'h');
      this.request_completed=1;
    }else{
      this.continue_request();
    }
  }
  
  crack_cap(item){
    var text;
    if(this.id_var.value == 'fumee'){
      text=this.cap.Capability.Layer.Layer[0].Layer[0].Layer[0].Layer[0].Dimension[0].values;
    } else {
      text=this.cap.Capability.Layer.Layer[0].Layer[0].Layer[0].Dimension[0].values;
    }	
    if(item == "dateo"){
      //2023-05-13T00:00:00Z/2023-05-23T00:00:00Z/PT3H
      //012345678901234567890123456789012345678901234567890
      //0         1         2         3         4
      return text.substring(0,20);
    } else if(item == "datef"){
      //2023-05-13T00:00:00Z/2023-05-23T00:00:00Z/PT3H
      //012345678901234567890123456789012345678901234567890
      //0         1         2         3         4
      return text.substring(21,41);
    } else if(item == "hhh_end"){
      //2023-05-13T00:00:00Z/2023-05-23T00:00:00Z/PT3H
      //012345678901234567890123456789012345678901234567890
      //0         1         2         3         4
      return text.substring(21,40);
    } else if(item == "hh_min_delta_fcst"){
      //2023-05-13T00:00:00Z/2023-05-23T00:00:00Z/PT3H
      //012345678901234567890123456789012345678901234567890
      //0         1         2         3         4
      return text.substring(44,45);
    } else {
      console.error('In function crack_cap, item not supported: '+item);
      return null;
    }
  }
  
  get_date_from_wms_date_stmp(wms_date,zone){
    //2023-05-13T12:00:00
    //0123456789012345678
    //0         1
    var res = new Date(wms_date);
    if(zone == 'local'){
      return new Date(res.getTime());
    } else if(zone == 'UTC'){
      return res;
    } else {
      console.error("Error in get_date_from_wms_date_stmp, unsuported zone: "+zone);
      return null;
    }
    
  }
  
  async get_layer_capability(){
    const parser = new WMSCapabilities();
    var my_url=this.ec_wms_url+"&REQUEST=GetCapabilities&Layers="+this.mod_lay
    return fetch(my_url)
      .then(function (response) {
	return response.text();
      })
      .then(function (text) {
	const result = parser.read(text);
	// Pour tout voir a la console :
	console.log(JSON.stringify(result, null, 2));
	return result;
      })
      .catch((error) => {
	console.error('Error with fetch on GetCapabilities');
      });
  }
  
  continue_request(){
    if(this.id_model.value == "HRDPS"){
      var region='.CONTINENTAL_';
    }else if(this.id_model.value == "RDPS" || this.id_model.value == "GDPS"){
      var region='.ETA_';
    }else if(this.id_model.value == "RAQDPS" ){
      var region='.';
    }else {
      alert('Internal error in class Time_Series, add variable '+this.id_model.value+' to set region');
      return;
    }
    if(this.id_var.value == 'temp'){
      var var_list=['TT','ES'];
    }else if (this.id_var.value == 'pcpntype' ){
      var var_list=['SN','RN','FR','PR'];
    }else if (this.id_var.value == 'PE'){
      // Note ice pellets = PR - (SN+RN+FR)
      var var_list=['SN','RN','FR','PR'];
    }else if (this.id_var.value == 'SN'){
      var var_list=['SN'];
    }else if (this.id_var.value == 'RN'){
      var var_list=['RN'];
    }else if (this.id_var.value == 'FR'){
      var var_list=['FR'];
    }else if (this.id_var.value == 'PR'){
      var var_list=['PR'];
    }else if (this.id_var.value == 'wind'){
      var var_list=['WSPD','WGE','WD'];	    
    }else if (this.id_var.value == 'NT'){
      var var_list=['NT','N4'];	    
    }else if (this.id_var.value == 'fumee'){
      var var_list=['EATM_PM2.5','SFC_PM2.5'];	    
    } else {
      alert('Internal error in class Time_Series, add variable '+this.id_var.value+' to set var_list');
      return;
    }
    var mod_lays = new Array(var_list.length);
    for (let i=0; i < var_list.length; i++){
      mod_lays[i]=this.id_model.value+region+var_list[i];
    }
    console.log(mod_lays);
    // Make sure (now) hour is a multiple of this.hh_min_delta_fcst.
    // If it is not, then subtract remaing
    if(this.id_start.value == "now"){
      this.now=new Date();
    }else if(this.id_start.value == "dateo"){
      this.now = new Date(this.dateo.valueOf())
    }else{
      alert("Internal error in series.js, add option "+this.id_start.value);
      return;
    }
    var res = Get_Wms_date_format(this.now,true);
    var remainder = res % this.hh_min_delta_fcst
    if(remainder != 0 ){
      this.now.setHours(this.now.getHours()-remainder);
    }
    // Set min sec millsec to zero
    this.now.setMinutes(0);
    this.now.setSeconds(0);
    this.now.setMilliseconds(0);
    // Figure out the number of forecasts needed (nhour).
    // Consider this time line. Note that this.now may be equal to this.dateo.
    // |---------------|------------|---------------------------------|------------------------------>
    // t0=this.dateo   t=this.now   te=(this.now+this.id_end.value)   tef=(this.dateo+this.hhh_end)
    // te must be smaller or equal to tef
    // Compute all dates in UTC to avoid problem with spring and fall time changes.
    var t0_utc = Date.UTC(this.dateo.getUTCFullYear(), this.dateo.getUTCMonth(),
			  this.dateo.getUTCDate(), this.dateo.getUTCHours(),
			  this.dateo.getUTCMinutes(), this.dateo.getUTCSeconds());
    var t_utc = Date.UTC(this.now.getUTCFullYear(), this.now.getUTCMonth(),
			 this.now.getUTCDate(), this.now.getUTCHours(),
			 this.now.getUTCMinutes(), this.now.getUTCSeconds());
    var te_utc = t_utc + parseInt(this.id_end.value)*3600*1000;
    var tef_utc = t0_utc + parseInt(this.hhh_end)*3600*1000;
    //console.log('this.dateo = '+this.dateo.toUTCString());
    var t0_utc_d = new Date(t0_utc);
    //console.log('t0  = '+t0_utc_d.toUTCString());
    var t_utc_d = new Date(t_utc);
    //console.log('t   = '+t_utc_d.toUTCString());
    var te_utc_d = new Date(te_utc);
    //console.log('te  = '+te_utc_d.toUTCString());
    var tef_utc_d = new Date(tef_utc);
    //console.log('tef = '+tef_utc_d.toUTCString());
    var nhours = parseInt(this.id_end.value)/parseInt(this.id_delta.value) + 1;
    if(te_utc > tef_utc ){
      // Request is too long by te_utc - tef_utc
      var diff_hh = (te_utc - tef_utc)/(3600*1000);
      nhours=nhours-Math.round(diff_hh/parseInt(this.id_delta.value));
      remainder = diff_hh % parseInt(this.id_delta.value);
      if(remainder != 0 ){
	nhours=nhours-1;
      }
    }
    //console.log('nhours = ',String(nhours));
    var lats = new Array(nhours);
    var lons = new Array(nhours);
    var ref_lat = null;
    var ref_lon = null;
    var ff = new Array(nhours);
    for (let i = 0; i < nhours; i++) {
      ff[i] = new Array(mod_lays.length);
      lats[i] = new Array(mod_lays.length);
      lons[i] = new Array(mod_lays.length);
      for (let j = 0; j < mod_lays.length; j++) {
	ff[i][j]=-999.;
	lats[i][j]=-999.;
	lons[i][j]=-999.;
      }
    }
    var nij=nhours*mod_lays.length;
    console.table(nij);
    var fetchs = new Array(nhours*nij);
    var dates = new Array(nhours);
    for (let i = 0; i < nhours; i++) {
      dates[i] = this.get_graph_date_label();
      var date_stmp=Get_Wms_date_format(this.now);
      //dates[i] = Get_graph_date_format(this.now);
      for (let j = 0; j < mod_lays.length; j++) {
	var url=this.set_url(mod_lays[j],date_stmp);
	console.log(url);
	fetchs[i*nhours+j] = fetch(url,{signal})
	  .then((res) => res.json())
	  .then((data) => {
	    ff[i][j]=parseFloat(data.features[0].properties.value);
	    var loc_point=data.features[0].geometry.coordinates;
	    if(! ref_lat){
	      ref_lat=loc_point[0];
	      ref_lon=loc_point[1];
	    }
	    lats[i][j]=loc_point[0];
	    lons[i][j]=loc_point[1];
	    if(this.grid_point_circle){
	      this.grid_point_circle.clear();
	    }
	    this.grid_point_circle=this.circle(loc_point);
	    this.grid_point_coor=loc_point;
	    var count=0;
	    for (let k = 0; k < ff.length; k++){
	      for (let g = 0; g < mod_lays.length; g++){
		if(ff[k][g] > -998. ){
		  count++; 
		}
	      }
	    }
	    this.progress_bar.update_progress_bar(count/nij);
	    //console.log('i=' + i + 'percent='+ count/ff.length);
	    console.log(data);
	  }).catch((error) => {
	    // When there is non pcpn the WMS request returns an undefined
	    if(this.id_var.value == 'pcpntype' ||
	       this.id_var.value == 'PE' ||
	       this.id_var.value == 'SN' ||
	       this.id_var.value == 'RN' ||
	       this.id_var.value == 'FR' ){
	      ff[i][j]=0.;
	    }else{
	      ff[i][j]=null;
	    }
	    console.error('Error:', error);
	  });
      }
      // Increment date in UTC to avoid problem with spring and fall time changes.
      // Fist convert this.now to UTC
      var now_utc = Date.UTC(this.now.getUTCFullYear(), this.now.getUTCMonth(),
			     this.now.getUTCDate(), this.now.getUTCHours(),
			     this.now.getUTCMinutes(), this.now.getUTCSeconds());
      // Increment UTC date
      now_utc=now_utc+parseInt(this.id_delta.value)*3600*1000;
      //
      this.now = new Date(now_utc);
    }
    Promise.all(fetchs)
      .then((data) => {
	var OK=1;
	for (let j = 0; j < ff.length; j++){
	  for (let k = 0; k < mod_lays.length; k++){
	    if(ff[j][k] != null ){
	      //OK=0;
	      // Sometimes the grid point changes for request to request espcially with pcpn data
	      // so we check that they are consistent.
	      if(lats[j][k] < -998. || lons[j][k] < -998.){
	      }else{
		if(lats[j][k] != ref_lat ||
		   lons[j][k] != ref_lon ){
		  alert("Probleme consistence avec le point de grille "
			+"Point,j="
			+String(j)
			+",k="
			+String(k)
			+"Valeur="
			+String(ff[j][k])
			+", "
			+String(lats[j][k])
			+","
			+String(ref_lat)
			+" | "
			+String(lons[j][k])
			+","
			+String(ref_lon));
		}
	      }
	    }
	  }
	}
	if(OK == 0){
	  this.id_message.innerHTML = "Probl&egrave;me avec le t&eacute;l&eacute;chargement de certaines donn&eacute;es"
	  this.progress_bar.reset_progress_bar(0.);
	  return
	}
	if(this.id_var.value == 'temp'){
	  graph_temp(this,dates,ff);
	}else if (this.id_var.value == 'pcpntype'){
	  graph_pcpn(this,dates,ff,'ALL');
	}else if (this.id_var.value == 'PE'){
	  graph_pcpn(this,dates,ff,'PE');
	}else if (this.id_var.value == 'SN'){
	  graph_pcpn(this,dates,ff,'SN');
	}else if (this.id_var.value == 'RN'){
	  graph_pcpn(this,dates,ff,'RN');
	}else if (this.id_var.value == 'FR'){
	  graph_pcpn(this,dates,ff,'FR');
	}else if (this.id_var.value == 'PR'){
	  graph_pcpn(this,dates,ff,'PR');
	}else if (this.id_var.value == 'wind'){
	  graph_wind(this,dates,ff);
	}else if (this.id_var.value == 'NT'){
	  graph_flux_solaire(this,dates,ff,parseInt(this.id_delta.value));
	}else if (this.id_var.value == 'fumee'){
	  graph_fumee(this,dates,ff);
	} else {
	  alert('Internal error in Promise.all(fetchs), add variable '+this.id_var.value);
	  return;
	}
	this.progress_bar.update_progress_bar(1.);
	this.progress_bar.reset_progress_bar(0.);
	this.request_completed=1;
	this.id_message.innerHTML = "Donn&eacute;es charg&eacute;es : mod&egrave;le "+this.id_model.value+", date d'origine "+this.dateo_stmp+", point de grille ("+ this.grid_point_coor+")"
      }).catch((error) => {
	console.error('Error:', error);
      });
  }
  
  get_graph_date_label(){
    var dt = new Date(this.now.valueOf());
    const weekday = ["dim","lun","mar","mer","jeu","ven","sam"];
    var day=dt.getDay();
    return weekday[day] +' '+ String(dt.getHours()).padStart(2, '0') + 'h';
  }    
  
  circle(point,color='red'){
    var style = new Style({
      stroke: new Stroke({
	color: color,
	width: 5
      }),
    });
    var featureCircle = new Feature({
      geometry: new Circle(fromLonLat(point),4000)
    });
    featureCircle.setStyle(style);
    var sourceCircle = new sourceVector({
      projection: 'EPSG:4326',
      features: [featureCircle]
    });
    var vectorCircle = new layerVector({
      source: sourceCircle
    });
    this.map.addLayer(vectorCircle);
    return sourceCircle;
  }
  
  set_url(mod_lay,date_stmp){
    return this.ec_wms_url+'&REQUEST=GetFeatureInfo&INFO_FORMAT=application/json&WIDTH=10&HEIGHT=10&I=5&J=5'+'&LAYERS='+mod_lay+'&QUERY_LAYERS='+mod_lay+'&CRS=EPSG:4326&BBOX='+this.bbox+'&TIME=' + date_stmp + '&DIM_REFERENCE_TIME='+ this.dateo_stmp;
  }
  
  cre_cook(nom,contenu) {
    localStorage.setItem(nom,contenu);
  }
  lir_cook(nom) {
    var res = localStorage.getItem(nom);
    if(res){
      return res;
    }else{
      return "";
    }
  }   
}

function Get_First_Date(date){
  var res = new Date();
  res.setFullYear(date.getFullYear());
  res.setDate(date.getDate());
  res.setHours(date.getHours());
  res.setMinutes(0);
  res.setSeconds(0);
  res.setMilliseconds(0);
  return res;
}
function Get_Wms_date_format(date,hour_only=false){
  var yyyy = String(date.getUTCFullYear())
  var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
  var dd = String(date.getUTCDate()).padStart(2, '0');
  var hh = String(date.getUTCHours()).padStart(2, '0');
  if(hour_only){
    return hh;
  }else{
    return yyyy + '-' + mm  + '-' + dd + 'T' + hh + ':00:00Z';
  }
}

function Get_graph_date_format(date){
  var yyyy = String(date.getFullYear())
  var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
  var dd = String(date.getDate()).padStart(2, '0');
  var hh = String(date.getHours()).padStart(2, '0');
  //return yyyy + '-' + mm  + '-' + dd +' '+ hh + ':00:00';
  const weekday = ["dim","lun","mar","mer","jeu","ven","sam"];
  let day = weekday[date.getDay()];
  return day + ' ' + hh ;
}

class Progress_bar {
  
  constructor(canvas){
    this.canvas=canvas;
  }
  
  update_progress_bar(percent){
    var ctx = this.canvas.getContext("2d");
    if(percent < .0001){
      ctx.fillStyle = "#FFF";
    } else {
      ctx.fillStyle = "#BBB";
    }
    ctx.fillRect(0, .4*this.canvas.height, this.canvas.width, .2*this.canvas.height);
    //console.log('Bar width:' +percent*this.canvas.width);
    ctx.fillStyle = "#F00";
    ctx.fillRect(0, .4*this.canvas.height, percent*this.canvas.width, .2*this.canvas.height);
  }
  
  reset_progress_bar(){
    this.update_progress_bar(0);
    this.precent=0.
  }
  
}

export {Time_Series}
